
import Component, { ComponentMethods } from "@/module/component/component"
import Request, { RequestPage } from "@/module/request/request"
import DateUtils from "@/module/utils/date"
import Message from "@/module/interactive/message"
import Utils from "@/module/utils/utils"

import elemIcon from "@/components/elem-icon.vue"
import elemOptions from "@/components/elem-options.vue"
import compEntity from "@/components/comp-entity.vue"

class MessageView extends ComponentMethods implements ComponentEntity {
    public title: string = "消息管理"

    private messages = null

    private page: number = 1
    private totalPages: number = 1

    private allCount: number = 0
    private unreadCount: number = 0

    private menuActivity: string = "ALL"

    private menu: obj[] = null

    private entityUuid: string = null

    private requestPage: RequestPage<obj>

    components = {
        elemIcon,
        elemOptions,
        compEntity,
    }

    private dateToString = DateUtils.toString.bind(DateUtils)

    onScroll(evt: Event) {
        const e = Utils.getTarget<HTMLDivElement>(evt)

        if (e.clientHeight + e.scrollTop === e.scrollHeight) {
            this.requestPage.load()
        }
    }

    created() {
        this.getMessageInfo()

        this.requestPage = new RequestPage("ADMIN://Message/FindAllToPage", {
            load: false,
            onChange: res => {
                this.messages = res
            },
        })
    }

    mounted() {
        this.$refs.message_box.menu = [
            {
                id: "read",
                icon: "have_read",
                name: "标记已读",
                onCreate: (evt: obj, menu: obj) => {
                    Utils.find<HTMLDivElement>(
                        evt.path,
                        c => c.classList.contains("message-item"),
                        v => {
                            let e = v.data
                            let i = e.getAttribute("uuid")

                            if (Utils.isExist(i)) {
                                Utils.find<obj>(
                                    this.messages,
                                    c => c.uuid === i,
                                    v => {
                                        if (v.data.readStatus === 0) {
                                            menu.id = "read"
                                            menu.icon = "have_read"
                                            menu.name = "标记已读"
                                        } else {
                                            menu.id = "unread"
                                            menu.icon = "unread"
                                            menu.name = "标记未读"
                                        }
                                    }
                                )
                            }
                        }
                    )
                },
                onClick: (evt: obj, id: string) => {
                    Utils.find<HTMLDivElement>(
                        evt.path,
                        c => c.classList.contains("message-item"),
                        v => {
                            let e = v.data
                            let i = e.getAttribute("uuid")

                            if (Utils.isExist(i)) {
                                this.markReadStatus(i, id === "read")
                            }
                        }
                    )
                },
            },
            {
                id: "read_all",
                icon: "have_read",
                name: "标记所有已读",
                onClick: () => {
                    this.markReadStatusAll(true)
                },
            },
            {
                id: "unread_all",
                icon: "unread",
                name: "标记所有未读",
                onClick: () => {
                    this.markReadStatusAll(false)
                },
            },
        ]
    }

    onLoad(param: obj) {
        if (param.i) {
            this.requestPage.setUrl("ADMIN://Message/FindAllUnreadToPage")

            this.menuActivity = "UNREAD"
        } else {
            this.requestPage.setUrl("ADMIN://Message/FindAllToPage")

            this.menuActivity = "ALL"
        }
    }

    private markReadStatusAll(read: boolean): void {
        Request.post("ADMIN://Message/MarkReadStatusAll", { status: read ? 1 : 0 }).then(() => {
            Utils.each<obj>(this.messages, v => {
                v.readStatus = read ? 1 : 0
            })

            if (read) {
                // 未读数量清空
                this.unreadCount = 0
            } else {
                this.unreadCount = this.allCount
            }

            Message.success("标记成功")
        })
    }

    private markReadStatus(i: string, read: boolean): void {
        Request.post("ADMIN://Message/MarkReadStatus", { message: i, status: read ? 1 : 0 }).then(() => {
            Utils.find<obj>(
                this.messages,
                c => c.uuid === i,
                v => {
                    v.data.readStatus = read ? 1 : 0
                }
            )

            if (read) {
                this.unreadCount--
            } else {
                this.unreadCount++
            }

            Message.success("标记成功")
        })
    }

    private getMessageInfo() {
        Request.get<obj>("ADMIN://Message/FindInfo").then(res => {
            this.allCount = res.all
            this.unreadCount = res.unread
            this.menu = res.menu
        })
    }

    /**
     * 获取消息图标
     */
    private getMessageIcon(type: string, dark: boolean = false): string {
        var name: string

        switch (type) {
            case "ERROR":
                name = "error"
                break
            case "SUCCESS":
                name = "success"
                break
            default:
                name = "info"
        }

        if (dark) {
            name += "_dark"
        }

        return name
    }

    /**
     * 监听菜单改变事件
     */
    public onChangeMenuActivity(source: string): void {
        var url: string

        switch (source) {
            case "ALL":
                url = "ADMIN://Message/FindAllToPage"
                break
            case "UNREAD":
                url = "ADMIN://Message/FindAllUnreadToPage"
                break
            default:
                url = "ADMIN://Message/FindAllBySourceToPage?source=" + source
        }

        this.requestPage.setUrl(url)

        this.menuActivity = source
    }

    /**
     * 监听删除事件
     */
    public onDelete(i: string): void {
        Message.info("确认删除该消息？", true)
            .onConfirm(() => {
                Request.delete("ADMIN://Message/Delete", { i }).then(() => {
                    Utils.each<obj>(
                        this.messages,
                        () => "delete",
                        c => c.uuid === i
                    )
                    Message.success("删除成功")
                })
            })
            .build()
    }

    public onOpenEntity(i: string): void {
        // 标记为已读
        Utils.find<obj>(
            this.messages,
            c => c.uuid === i,
            v => {
                let data = v.data

                if (data.readStatus === 0) {
                    data.readStatus = 1
                    // 未读数量自减
                    this.unreadCount--
                }
            }
        )
        this.$refs.comp_entity.open(i)
    }
}

export default Component.build(new MessageView())
